import script from "./TaskCardAchievements.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardAchievements.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardAchievements.vue?vue&type=style&index=0&id=21f84f5f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f84f5f"]])

export default __exports__